module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 remove-margins"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 hidden-xs hidden-sm"
  }, [_c('h3', {
    staticClass: "text-center text-muted",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("\n        Feedback and Performance\n      ")]), _vm._v(" "), _c('FeedbackAndPerformance', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 hidden-xs hidden-sm"
  }, [_c('h3', {
    staticClass: "text-center text-muted",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n        Shortcuts\n      ")]), _vm._v(" "), _c('Shortcuts')], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs hidden-md hidden-lg"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/dashboard/feedback-performance"
    }
  }, [_c('a', [_vm._v("Performance")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/dashboard/shortcuts"
    }
  }, [_c('a', [_vm._v("Shortcuts")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content hidden-md hidden-lg"
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center hidden-sm hidden-xs"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Dashboard, profile and activity summary\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-10 col-sm-offset-1"
  }, [_c('hr', {
    staticClass: "hidden-xs hidden-sm",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center hidden-md hidden-lg"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Dashboard, profile and activity summary\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0250c3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Dashboard.vue
// module id = 648
// module chunks = 2